module.exports = __webpack_public_path__ + "img/service2.b91197fb.png";